import PropTypes from 'prop-types';
import React from 'react';
import * as constants from '../../backend/constants';
import TextFieldEditor from '../text-field-editor/TextFieldEditor.jsx';

import s from './BulkChangeConfigurator.module.scss';

const BulkTextField = ({ value, fieldConfig, onChange, changeType }) => {
    if (changeType === constants.BULK_CHANGE_CONFIGURATOR_CHANGE_TYPE.REPLACE) {
        return (
            <div>
                <div className={s.dividerWithText}>With the following...</div>
                <TextFieldEditor className={s.editor} value={value} placeHolder={fieldConfig.placeholder} onChange={onChange} />
            </div>
        );
    }
    return null;
};

BulkTextField.propTypes = {
    fieldConfig: PropTypes.object,
    value: PropTypes.string,
    onChange: PropTypes.func,
    changeType: PropTypes.string,
};

export default BulkTextField;
